import React from 'react'
import Table from '../../components/Table'
import EditCompleteIcon from '@material-ui/icons/EditOutlined'
import LigaDesliga from '@material-ui/icons/PowerSettingsNew'
import IconeAtivo from '@material-ui/icons/CheckCircle'
import IconeInativo from '@material-ui/icons/Cancel'
import SenhaIcon from '@material-ui/icons/VpnKey'
import { colors } from '@material-ui/core'
import VisulizarIcon from '@material-ui/icons/SearchOutlined'

export default function UsuarioListagem(props) {
    const colunas = [
        { title: 'Nome Completo', field: 'nomeCompleto', editable: 'never' },
        { title: 'Usuário', field: 'usuario', editable: 'never' },
        { title: 'Email', field: 'email', editable: 'never' },
        {
            title: 'Situação',
            field: 'ativo',
            editable: 'never',
            render: (rowData) =>
                rowData.ativo ? (
                    <IconeAtivo style={{ color: colors.green[800] }} />
                ) : (
                    <IconeInativo style={{ color: colors.red[500] }} />
                ),
        },
    ]

    return (
        <>
            <Table
                title={'Listagem'}
                columns={colunas}
                data={props.data}
                onChangePage={(page) => props.onChangePage(page)}
                page={props.filtro.page}
                totalCount={props.filtro.totalItens ? props.filtro.totalItens : 0}
                isLoading={props.isLoading}
                pageSize={props.pageSize}
                onOrderChange={(numeroColuna, orientacao) =>
                    props.mudaOrdenacao(numeroColuna, orientacao, colunas)
                }
                emptyRowsWhenPaging={false}
                editarCelula={props.editarCelula ? props.editarCelula : null}
                actions={[
                    {
                        icon: LigaDesliga,
                        tooltip: 'Ativar / Desativar',
                        onClick: (event, rowData) =>
                            props.ativarDesativar(rowData.id),
                        disabled: !props.editarPermissao
                    },
                    {
                        icon: EditCompleteIcon,
                        tooltip: 'Edição',
                        onClick: (event, rowData) => props.editar(rowData.id),
                        disabled: !props.editarPermissao
                    },
                    {
                        icon: SenhaIcon,
                        tooltip: 'Alterar Senha',
                        onClick: (event, rowData) => props.alterarSenha(rowData.id),
                        disabled: !props.editarPermissao
                    },
                    {
                        icon: VisulizarIcon,
                        tooltip: 'Visualizar',
                        onClick: (event, rowData) => props.visualizar(rowData),
                        disabled: !props.visualizarPermissao
                    },
                ]}
                editable={{
                    onRowDelete: (item) =>  props.deletar(item),
                    isDeletable: rowData => props.deletarPermissao
                }}
            />
        </>
    )
}
